"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _base = _interopRequireDefault(require("./base"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Docs = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Docs, _Component);

  var _super = _createSuper(Docs);

  function Docs() {
    (0, _classCallCheck2["default"])(this, Docs);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Docs, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_base["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M23.62,23.41a1,1,0,0,1,.39.08,1,1,0,0,0-.78,0A1,1,0,0,1,23.62,23.41Z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M32,57.5A24.83,24.83,0,1,1,56.83,32.67,24.86,24.86,0,0,1,32,57.5Zm0-44.86a20,20,0,1,0,20,20A20,20,0,0,0,32,12.64Z"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "28.8",
        y: "29.46",
        width: "6.41",
        height: "16.02",
        rx: "1.6",
        ry: "1.6"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "28.8",
        y: "19.85",
        width: "6.41",
        height: "6.41",
        rx: "1.6",
        ry: "1.6"
      }));
    }
  }]);
  return Docs;
}(_react.Component);

exports["default"] = Docs;
(0, _defineProperty2["default"])(Docs, "defaultProps", {
  height: '16px',
  predefinedClassName: 'data-ex-icons-docs'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21tb24vaWNvbnMvZG9jcy50c3giXSwibmFtZXMiOlsiRG9jcyIsInByb3BzIiwiQ29tcG9uZW50IiwiaGVpZ2h0IiwicHJlZGVmaW5lZENsYXNzTmFtZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFHQTs7QUFDQTs7Ozs7O0lBRXFCQSxJOzs7Ozs7Ozs7Ozs7V0FNbkIsa0JBQVM7QUFDUCwwQkFDRSxnQ0FBQyxnQkFBRCxFQUFVLEtBQUtDLEtBQWYsZUFDRTtBQUFNLFFBQUEsQ0FBQyxFQUFDO0FBQVIsUUFERixlQUVFO0FBQU0sUUFBQSxDQUFDLEVBQUM7QUFBUixRQUZGLGVBR0U7QUFBTSxRQUFBLENBQUMsRUFBQyxNQUFSO0FBQWUsUUFBQSxDQUFDLEVBQUMsT0FBakI7QUFBeUIsUUFBQSxLQUFLLEVBQUMsTUFBL0I7QUFBc0MsUUFBQSxNQUFNLEVBQUMsT0FBN0M7QUFBcUQsUUFBQSxFQUFFLEVBQUMsS0FBeEQ7QUFBOEQsUUFBQSxFQUFFLEVBQUM7QUFBakUsUUFIRixlQUlFO0FBQU0sUUFBQSxDQUFDLEVBQUMsTUFBUjtBQUFlLFFBQUEsQ0FBQyxFQUFDLE9BQWpCO0FBQXlCLFFBQUEsS0FBSyxFQUFDLE1BQS9CO0FBQXNDLFFBQUEsTUFBTSxFQUFDLE1BQTdDO0FBQW9ELFFBQUEsRUFBRSxFQUFDLEtBQXZEO0FBQTZELFFBQUEsRUFBRSxFQUFDO0FBQWhFLFFBSkYsQ0FERjtBQVFEOzs7RUFmK0JDLGdCOzs7aUNBQWJGLEksa0JBQ0c7QUFDcEJHLEVBQUFBLE1BQU0sRUFBRSxNQURZO0FBRXBCQyxFQUFBQSxtQkFBbUIsRUFBRTtBQUZELEMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBTUERYLUxpY2Vuc2UtSWRlbnRpZmllcjogTUlUXG4vLyBDb3B5cmlnaHQgY29udHJpYnV0b3JzIHRvIHRoZSBrZXBsZXIuZ2wgcHJvamVjdFxuXG5pbXBvcnQgUmVhY3QsIHtDb21wb25lbnR9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBCYXNlLCB7QmFzZVByb3BzfSBmcm9tICcuL2Jhc2UnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBEb2NzIGV4dGVuZHMgQ29tcG9uZW50PFBhcnRpYWw8QmFzZVByb3BzPj4ge1xuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIGhlaWdodDogJzE2cHgnLFxuICAgIHByZWRlZmluZWRDbGFzc05hbWU6ICdkYXRhLWV4LWljb25zLWRvY3MnXG4gIH07XG5cbiAgcmVuZGVyKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8QmFzZSB7Li4udGhpcy5wcm9wc30+XG4gICAgICAgIDxwYXRoIGQ9XCJNMjMuNjIsMjMuNDFhMSwxLDAsMCwxLC4zOS4wOCwxLDEsMCwwLDAtLjc4LDBBMSwxLDAsMCwxLDIzLjYyLDIzLjQxWlwiIC8+XG4gICAgICAgIDxwYXRoIGQ9XCJNMzIsNTcuNUEyNC44MywyNC44MywwLDEsMSw1Ni44MywzMi42NywyNC44NiwyNC44NiwwLDAsMSwzMiw1Ny41Wm0wLTQ0Ljg2YTIwLDIwLDAsMSwwLDIwLDIwQTIwLDIwLDAsMCwwLDMyLDEyLjY0WlwiIC8+XG4gICAgICAgIDxyZWN0IHg9XCIyOC44XCIgeT1cIjI5LjQ2XCIgd2lkdGg9XCI2LjQxXCIgaGVpZ2h0PVwiMTYuMDJcIiByeD1cIjEuNlwiIHJ5PVwiMS42XCIgLz5cbiAgICAgICAgPHJlY3QgeD1cIjI4LjhcIiB5PVwiMTkuODVcIiB3aWR0aD1cIjYuNDFcIiBoZWlnaHQ9XCI2LjQxXCIgcng9XCIxLjZcIiByeT1cIjEuNlwiIC8+XG4gICAgICA8L0Jhc2U+XG4gICAgKTtcbiAgfVxufVxuIl19